var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('date-picker',{staticClass:"shedule__date",attrs:{"type":"datetime","format":"dd-MM-yyyy HH:mm","picker-options":_vm.pickerOptions,"value-format":"yyyy-MM-dd HH:mm","placeholder":_vm.$t('Выберите дату последнего обновления'),"name":"shedule"},model:{value:(_vm.date),callback:function ($$v) {_vm.date=$$v},expression:"date"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }